import { SET_CLIENT_AREA, SET_CLIENT_AREA_PLANS, CLEAR_CLIENT_AREA, HANDLE_LOADING, HANDLE_PLANS_LOADING, HANDLE_SEND_EMAIL_LOADING } from './constants';

const defaultState = {
  isLoading: false,
  isPlansLoading: false,
  isSendEmailLoading: false,
  futureCharges: [],
  charges: [],
  subscriptions: [],
  plans: []
}

export default (state = defaultState, action) => {
  switch (action.type) {
    case SET_CLIENT_AREA: {
      return {
        ...state,
        futureCharges: action?.data?.futureCharges || [],
        charges: action?.data?.charges || [],
        subscriptions: action?.data?.subscriptions || []
      }
    }
    case SET_CLIENT_AREA_PLANS: {
      return {
        ...state,
        plans: action?.data || []
      }
    }
    case CLEAR_CLIENT_AREA: {
      return {
        ...state,
        charges: [],
        subscriptions: []
      }
    }
    case HANDLE_LOADING: {
      return {
        ...state,
        isLoading: action?.status
      }
    }
    case HANDLE_PLANS_LOADING: {
      return {
        ...state,
        isPlansLoading: action?.status
      }
    }
    case HANDLE_SEND_EMAIL_LOADING: {
      return {
        ...state,
        isSendEmailLoading: action?.status
      }
    }
    default: {
      return state;
    }
  }
}